export const navbarHeight = 70;

export const sidebarWidth = 300;

export const searchModalWidth = 400;
